import React from 'react';
import { OnboardingClasses } from '../onboarding.enums';
import { OnboardingStep } from '../onboarding.types';

export const OPTION_TOUR: OnboardingStep[] = [
    {
        className: OnboardingClasses.OPTIONS_CARDS,
        nextOnTargetClick: true,
        title: 'Option',
        placement: 'right',
        borderRadius: 18,
        content: (
            <>
                Aside from the main product you may have supplementary services
                that can be free of charge or incur extra charges on the
                customer. For example - optional lunch, or optional guide
                service, etc.
            </>
        ),
    },
    {
        className: OnboardingClasses.ADD_OPTION_BUTTON,
        nextOnTargetClick: true,
        title: 'Pricing Option',
        placement: 'right',
        borderRadius: 4,
        content: `Tap Add product option button`,
    },
    {
        className: OnboardingClasses.OPTION_CARD,
        title: 'Payment Methods',
        waitForTarget: true,
        placement: 'right',
        borderRadius: 4,
        content: (
            <>
                Explore the various types that Travelity supports.
                <br />
                Find a meaningful name for your product option.
                <br /> <br />
                Optionally add pricing to your product option. Note that Product
                options can have as many pricing options as needed.
            </>
        ),
    },
];
